import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

const LinkPreview = ({ linkData }) => {
  if (!linkData || !linkData.url) return null;

  return (
    <a
      href={linkData.url}
      target="_blank"
      rel="noopener noreferrer"
      className="block border border-gray-200 rounded-xl overflow-hidden hover:border-[#4A90E2]/40 transition-colors group"
      data-testid="link-preview"
    >
      {linkData.image && (
        <div className="h-44 bg-gray-100 overflow-hidden">
          <img
            src={linkData.image}
            alt=""
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      )}
      <div className="p-3">
        <div className="flex items-center space-x-1.5 mb-1">
          <span className="text-[10px] text-gray-400 uppercase tracking-wide">{linkData.domain || linkData.site_name}</span>
          <FaExternalLinkAlt className="text-gray-300" size={8} />
        </div>
        <p className="text-sm font-semibold text-gray-900 line-clamp-2 group-hover:text-[#4A90E2] transition-colors">
          {linkData.title}
        </p>
        {linkData.description && (
          <p className="text-xs text-gray-500 mt-1 line-clamp-2">{linkData.description}</p>
        )}
      </div>
    </a>
  );
};

export default LinkPreview;
